import {Message} from '../../../_metronic/helpers'
import {getEmploymentTypesById} from '../../../api/EmploymentType'
import {EmploymentTypeInput} from '../../types/AdminModuleTypes'
import {APIResponse, InputErrorType, TableHeaderDataType} from '../../types/OtherTypes'

export const validateForm = (formField: EmploymentTypeInput) => {
  let cnt: number = 0
  const error: InputErrorType = {}
  let alphaRegex = /^[a-z][a-z .'-]*[a-z]*$/i
  let addressRegex = /^[a-zA-Z0-9][\w\W]*[a-zA-Z0-9)]+$/
  let addressInvalidCharacters = /[<>:"\\|?*\x00-\x1F~`!@#^+=;'[\]{}%_&$]/
  if (!formField.name.trim()) {
    cnt = cnt + 1
    error.name = 'Leave name is Required'
  } else {
    if (!alphaRegex.test(formField.name.trim())) {
      cnt = cnt + 1
      error.name =
        "Only letters (a-z,A-Z) and single space , . , ', - between two characters are allowed and last or first character of the Leave name must be letter (a-z,A-Z)"
    } else if (/(?=([^\w\d]))\1{2,}/g.test(formField.name.trim())) {
      cnt = cnt + 1
      error.name =
        "Only letters (a-z,A-Z) and single space , . , ' , - between two characters are allowed and last or first character of the Leave name must be letter (a-z,A-Z)"
    } else {
      if (formField.name.replaceAll(' ', '').length > 50) {
        cnt = cnt + 1
        error.name = 'Leave name should not be greater than 50 characters'
      }
    }
  }

  if (!formField.description) {
    cnt = cnt + 1
    error.description = 'Description is Required'
  } else if (formField.description.length > 100) {
    cnt = cnt + 1
    error.description = 'Description must be 100 characters or fewer.'
  }

  if (!formField.duration) {
    cnt = cnt + 1
    error.duration = 'Duration is Required'
  } else {
    if (Number(formField.duration) <= 0) {
      cnt = cnt + 1
      error.duration = 'Duration should be greater than zero'
    } else if (formField.duration.toString().replaceAll('.', '').length > 4) {
      cnt = cnt + 1
      error.duration = 'Duration should not be greater than 4 digits'
    }
  }

  return {error, cnt}
}

export const getEmploymentTypeTableHeaderData = (isActionColumnNeeded: boolean) => {
  const employmentTypeTableHeaderData: TableHeaderDataType[] = [
    {
      th: {
        id: 'donorName',
        style: {
          minWidth: '100px',
          width: '100px',
        },
      },
      text: 'Employment Type',
      isSortable: false,
    },
    {
      th: {
        id: 'donorAddress',
        style: {
          minWidth: '90px',
          width: '90px',
        },
      },
      text: 'Duration',
      isSortable: false,
    },
    {
      th: {
        id: 'bloodType',
        style: {
          minWidth: '150px',
          width: '150px',
        },
      },
      text: 'Description',
      isSortable: false,
    },

    {
      th: {
        id: 'actions',
        style: {
          width: '50px',
          minWidth: '50px',
        },
        hidden: isActionColumnNeeded,
      },
      text: 'Actions',
      justifyContent: 'end',
      isSortable: false,
    },
  ]
  return {employmentTypeTableHeaderData}
}

export const getEmploymentTypeByID = (
  id: string,
  formField: EmploymentTypeInput,
  setFormField: Function,
  setEditId: Function,
  setShowForm: Function,
  setInputError: Function
) => {
  getEmploymentTypesById(id).then((res: APIResponse) => {
    if (res.statusCode === 200) {
      setFormField({
        ...formField,
        description: res?.data?.description,
        duration: res?.data?.duration?.toString() ?? '',
        name: res?.data?.name ?? '',
      })
      setEditId(id)
      setInputError({})
      setShowForm(true)
    } else {
      Message(res.message, 'error')
    }
  })
}
